<template>
    <div class="one-counter-area pt-100 pb-70">
        <div class="container">
            <div class="row text-center">
                <div class="col-sm-6 col-lg-3" v-for="item in countersToShow" :key="item.key">
                    <div class="counter-item-fixed">
                        <h3 class="counter-number">
                            <vue3-autocounter 
                                :startAmount="0" 
                                :endAmount="item.value" 
                                :duration="2" 
                            />
                        </h3>
                        <p class="counter-label">
                            {{ item.labelLine1 }}<br v-if="item.labelLine2">
                            <span v-if="item.labelLine2">{{ item.labelLine2 }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Counter',
    data() {
        return {
            // Plotix comenzó oficialmente en 2024
            baseDate: new Date('2024-10-01'),

            // Valores iniciales más realistas
            baseCounters: {
                years: 1,     // 1 año de experiencia
                repairs: 22,  // equipos reparados
                clients: 35,  // clientes satisfechos
                services: 41, // servicios técnicos realizados
            },
        };
    },
    computed: {
        diffDays() {
            const today = new Date();
            const diffTime = today - this.baseDate;
            return Math.floor(diffTime / (1000 * 60 * 60 * 24));
        },
        dynamicCounters() {
            return {
                years: this.baseCounters.years,
                repairs: this.baseCounters.repairs + Math.floor(this.diffDays * 0.05), // +1 cada ~20 días
                clients: this.baseCounters.clients + Math.floor(this.diffDays * 0.04), // +1 cada ~25 días
                services: this.baseCounters.services + Math.floor(this.diffDays * 0.06), // +1 cada ~16 días
            };
        },
        countersToShow() {
            return [
                {
                    key: 'years',
                    value: this.dynamicCounters.years,
                    labelLine1: 'AÑO DE',
                    labelLine2: 'EXPERIENCIA',
                },
                {
                    key: 'repairs',
                    value: this.dynamicCounters.repairs,
                    labelLine1: 'EQUIPOS',
                    labelLine2: 'REPARADOS',
                },
                {
                    key: 'clients',
                    value: this.dynamicCounters.clients,
                    labelLine1: 'CLIENTES',
                    labelLine2: 'SATISFECHOS',
                },
                {
                    key: 'services',
                    value: this.dynamicCounters.services,
                    labelLine1: 'SERVICIOS TÉCNICOS',
                    labelLine2: 'REALIZADOS',
                },
            ];
        },
    },
};
</script>

<style scoped>
.counter-item-fixed {
    text-align: center;
    margin-bottom: 30px;
}

.counter-number {
    font-size: 48px;
    font-weight: 700;
    line-height: 1.1;
    color: #fff;
    margin: 0 0 10px;
}

.counter-label {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    color: #fff;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: .05em;
}
</style>
